/* unplugin-vue-components disabled */import { render } from "./planDetail.vue?vue&type=template&id=4662cd90&scoped=true"
import script from "./planDetail.vue?vue&type=script&lang=js"
export * from "./planDetail.vue?vue&type=script&lang=js"

import "./planDetail.vue?vue&type=style&index=0&id=4662cd90&lang=less&scoped=true"

import exportComponent from "D:\\dianzhong\\cps-expert-popularize\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4662cd90"]])

export default __exports__